import { apiSlice } from '@/api/api.slice.tsx';

export interface AvailablePaymentListResponse {
  availablePayments: ('sepa_debit' | 'card' | 'wire_transfer')[];
}

const curr = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAvailablePaymentList: builder.query<AvailablePaymentListResponse, void>({
      query: () => ({
        url: '/available-payment-list',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetAvailablePaymentListQuery } = curr;
